import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  tag?: {
    title: string;
  };
  children?: ReactNode;
  onRemoveTag: () => void;
  className?: string;
}

export default function SessionTag(props: Props) {
  return (
    <div
      className={tw(
        "bg-bgGray",
        "border",
        "border-borderGray",
        "pl-6",
        "pr-3",
        "h-12",
        "rounded-full",
        "inline-block",
        "mr-2",
        "mb-2",
        props.className
      )}
    >
      <div className="flex h-full items-center">
        {props.tag && <div className="mr-2 flex-1">{props.tag.title}</div>}
        {props.children && (
          <div className="mr-2 flex-1 truncate">{props.children}</div>
        )}

        <div>
          <button
            type="button"
            className="cursor-pointer"
            onClick={props.onRemoveTag}
          >
            <i aria-hidden className="far fa-circle-xmark text-empty" />
          </button>
        </div>
      </div>
    </div>
  );
}
